<template>
  <div>
    <loading :active.sync="isLoading"></loading>

    <div class="custom-control custom-radio">
      <input type="radio" id="export_vtt" name="customRadio" class="custom-control-input" value="vtt"
             v-model="exportOption">
      <label class="custom-control-label" for="export_vtt">{{ $t('INSTANCE_EXPORT_OPTION_VTT') }}</label>
    </div>
    <div class="custom-control custom-radio">
      <input type="radio" id="export_srt" name="customRadio" class="custom-control-input" value="srt"
             v-model="exportOption">
      <label class="custom-control-label" for="export_srt">{{ $t('INSTANCE_EXPORT_OPTION_SRT') }}</label>
    </div>
    <div class="custom-control custom-radio">
      <input type="radio" id="export_backend" name="customRadio" class="custom-control-input" value="backend"
             v-model="exportOption">
      <label class="custom-control-label" for="export_backend">{{ $t('INSTANCE_EXPORT_OPTION_BACKEND') }}</label>
    </div>

    <button class="btn btn-primary mt-4" @click="startExport">
      {{ $t('INSTANCE_EXPORT_CONFIRMATION_BUTTON') }}
    </button>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import { RepositoryFactory } from '../../../../repositories/RepositoryFactory';

const InstanceExportRepository = RepositoryFactory.get('instanceExport');

export default {
  name: 'InstanceExport',
  data() {
    return {
      exportOption: 'vtt',
      isLoading: false,
    };
  },
  components: { Loading },
  methods: {
    startExport() {
      switch (this.exportOption) {
        case 'vtt':
          this.isLoading = true;
          InstanceExportRepository.exportAsVTT()
            .then((res) => {
              this.downloadBlob(new Blob([res.data]), res.headers.filename);

              this.$snotify.info(this.$t('INSTANCE_EXPORT_DOWNLOAD_STARTED_TOAST_CONTENT'), this.$t('INSTANCE_EXPORT_DOWNLOAD_STARTED_TOAST_TITLE'), {
                timeout: 5000,
                showProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true,
                buttons: [
                  {
                    text: 'Download',
                    action: () => this.downloadBlob(new Blob([res.data]), 'export.vtt'),
                    bold: false,
                  },
                ],
              });
            })
            .catch(e => console.log(e))
            .finally(() => this.isLoading = false);
          break;
        case 'srt':
          this.isLoading = true;
          InstanceExportRepository.exportAsSRT()
            .then((res) => {
              this.downloadBlob(new Blob([res.data]), res.headers.filename);

              this.$snotify.info(this.$t('INSTANCE_EXPORT_DOWNLOAD_STARTED_TOAST_CONTENT'), this.$t('INSTANCE_EXPORT_DOWNLOAD_STARTED_TOAST_TITLE'), {
                timeout: 5000,
                showProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true,
                buttons: [
                  {
                    text: 'Download',
                    action: () => this.downloadBlob(new Blob([res.data]), 'export.srt'),
                    bold: false,
                  },
                ],
              });
            })
            .catch(e => console.log(e))
            .finally(() => this.isLoading = false);
          break;
        case 'backend':
          InstanceExportRepository.exportToBackend()
            .then((res) => {
              this.$snotify.success(this.$t('INSTANCE_EXPORT_EXPORTED_TO_BACKEND'));
            })
            .catch(e => console.log(e))
            .finally(() => this.isLoading = false);
          break;
        default:
          this.$snotify.error('Invalid Choice');
          break;
      }
    },
    downloadBlob(blob, filename) {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style scoped>

</style>
